import { Component } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { PurchaseOrderLineItem } from 'app/core/model/purchase-order-line-item';
import validationEngine from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-line-item-dialog',
    templateUrl: './line-item-dialog.component.html',
    styleUrls: ['./line-item-dialog.component.scss'],
    standalone: false
})
export class LineItemDialogComponent {
    result: Subject<any> = new Subject<any>();
    lineItem: PurchaseOrderLineItem;
    displayOrder: number;
    types = ['Item', 'Expense'];

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.lineItem) {
            this.lineItem = this.uow.purchaseOrderLineItems.createEntity({
                created: new Date(),
                displayOrder: this.displayOrder,
            }) as PurchaseOrderLineItem;
        }
    }

    typeChanged = (e) => {
        const selectedType = e.value;
        if (selectedType !== 'Expense') this.lineItem.quickBooksAccount = null;
    }

    async save() {
        const success = this.validate();
        if (!success) return;

        this.result.next({ success: true });
    }

    cancel() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('lineItemValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('lineItemValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
